import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { masterServices } from 'src/app/module/master/services/ems-services.service';
import { ordersService } from '../../services/orders.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-add-component',
  templateUrl: './add-component.component.html',
  styleUrls: ['./add-component.component.css']
})
export class AddComponentComponent {
  truckDetails: any;
  tyreList: any;
  batteryList: any;
  componantList: any;
serialNumber: any;
  selectedComponent: any;
  componentType: any;
  associationDate:any;
  associationStatus:any
associationkm:any
  associationType: any;
 maxDate: Date = new Date();
  constructor(
    public dialogRef: DynamicDialogRef,
        private datePipe: DatePipe,
        public data: DynamicDialogConfig,
        private masterServices: masterServices,
        private ordersService: ordersService,
        private messageService: MessageService
  ){
    console.log("data",data)

    this.truckDetails = data?.data?.data
    console.log(this.truckDetails)
  }


  onTypeChange(type:any){
    console.log(type)
    this.componentType = type

    const postData = [
      {
        key: 'COMPONENT_TYPE_IN',
        value: this.componentType,
      },
      {
        key: 'STATUS_IN',
        value: 'new,idle',
      }
    ];
    this.masterServices.getComponentInfo(postData, 0, 1000, 'id', 'DESC').subscribe((data: any) => {
            this.componantList = data?.responseObject?.content;
          this.serialNumber = ''
          if(this.componentType == 'tyre'){
            this.tyreList = data?.responseObject?.content;
          }else if(this.componentType == 'battery'){
            this.batteryList = data?.responseObject?.content;
          }
        },(err) => {
          this.componantList = []
          this.batteryList = [];
          this.tyreList = [];
        },
      );
  }

  onserialChange(event:any){
    console.log(event)
    const componant = this.componantList.find((s: any) => s.id === event);
    console.log(componant,'componantcomponant')
    this.selectedComponent = componant
  }
  onChangecomponentType(associationType:any){
    console.log(associationType)
      this.associationType = associationType
  }
  addComponent(){
  
    let associatedTyres = this.truckDetails?.associatedTyres || 0;
    let associatedTrailerTyres = this.truckDetails?.associatedTrailerTyres || 0;
    let associatedBatteries = this.truckDetails?.associatedBatteries || 0;

    if (this.selectedComponent?.componentType === "Tyre" 
      && this.associationType === "TRUCK"
      ) {
        if ((this.truckDetails?.tyreCapacity ?? 0) <= associatedTyres) {
          this.messageService.add({
            severity: 'warn',
            summary: 'Limit reached',
            detail: `Maximum ${this.truckDetails?.tyreCapacity} Truck tyres allowed`
          });
          return;
        }
        associatedTyres = associatedTyres + 1;
        // return ;
    }
    if (this.selectedComponent?.componentType === "Tyre" &&
        this.associationType === "TRAILER") {
      if((this.truckDetails?.trailerTyreCapacity ?? 0) <= associatedTrailerTyres){
          this.messageService.add({
            severity: 'warn',
            summary: 'Limit reached',
            detail: `Maximum ${this.truckDetails?.trailerTyreCapacity} Trailer tyres allowed`
          });
          return
        }
        associatedTrailerTyres = associatedTrailerTyres + 1;
      //   return false;
    }
    if (this.selectedComponent?.componentType === "Battery") {
      if((this.truckDetails?.batteryCapacity?? 0) <= associatedBatteries){
        this.messageService.add({
          severity: 'warn',
          summary: 'Limit reached',
          detail: `Maximum ${this.truckDetails?.associatedBatteries} Battery allowed`
        });
        return
      }
      associatedBatteries = associatedBatteries + 1;
      //   return false;
    }

    const payload = {
      id: this.truckDetails?.id,
      associatedTyres: associatedTyres,
      associatedTrailerTyres: associatedTrailerTyres,
      associatedBatteries: associatedBatteries ,
      'initialKmTravelled':this.associationkm,
      commponentAssociation:
          [
            {
            associationType: this.associationType,
            componentType:this.selectedComponent?.componentType,
            "newComponentId": this.selectedComponent?.id,
            "newComponentStatus": 'InUse',
            newComponentVersion: this.selectedComponent?.version ?? null,
            newComponentFromDate:this.associationDate ? this.datePipe.transform(this.associationDate, 'dd-MM-yyyy HH:mm:ss Z')  : null,

          }
      ],
    }
    console.log(payload)
    this.ordersService.getBuild(payload).subscribe((data: any) => {
      if (data) {
        console.log(data)
        this.dialogRef.close(data);
        // this._route.navigate(['/orders']);
      }
    })
  }
close(){
  this.dialogRef.close('data');
}





}
